import { useTranslation } from 'react-i18next';
import { Button } from '@/common/components/Button/Button';
import { ContextMenu } from '@/common/components/ContextMenu/ContextMenu';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useRouter } from 'expo-router';

export type TBudgetsContextMenuProps = {
  actionType: 'reimbursement' | 'childcare';
  budgets?: {
    id: string;
    name: string;
  }[];
};

export function BudgetsContextMenu({
  actionType,
  budgets = [],
}: TBudgetsContextMenuProps) {
  const { t } = useTranslation();
  const router = useRouter();

  if (!budgets.length) return null;

  const handlePress = (budgetId: string) => {
    if (actionType === 'childcare') {
      router.navigate({
        pathname: ROUTES.NEW_BUDGET_CHILDCARE_VOUCHER,
        params: { budgetEmployeeId: budgetId },
      });
    }

    if (actionType === 'reimbursement') {
      router.navigate({
        pathname: ROUTES.NEW_BUDGET_REIMBURSEMENT,
        params: { employeeBudgetID: budgetId },
      });
    }
  };

  const label =
    actionType === 'childcare'
      ? t('dashboard.budgets.details.childcare_button')
      : t('dashboard.benefits.details.actions.reimbursement.button_label');

  const icon = actionType === 'childcare' ? 'ticket-simple' : 'arrows-repeat';

  const options = budgets.map((budget) => ({
    label: budget.name,
    action: () => handlePress(budget.id),
  }));

  if (options.length === 1) {
    return (
      <Button
        icon={<Icon icon={icon} />}
        onPress={() => handlePress(budgets[0].id)}
      >
        {label}
      </Button>
    );
  }

  return (
    <ContextMenu
      title={label}
      trigger={<Button icon={<Icon icon={icon} />}>{label}</Button>}
      options={options}
    />
  );
}
